/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DishCategoryUpdate } from '../models/DishCategoryUpdate';
import type { SuccessResponse_AnomalyEvidence_ } from '../models/SuccessResponse_AnomalyEvidence_';
import type { SuccessResponse_ConsumptionStructure_ } from '../models/SuccessResponse_ConsumptionStructure_';
import type { SuccessResponse_CrowdStructure_ } from '../models/SuccessResponse_CrowdStructure_';
import type { SuccessResponse_DailyReport_ } from '../models/SuccessResponse_DailyReport_';
import type { SuccessResponse_DailyReportDates_ } from '../models/SuccessResponse_DailyReportDates_';
import type { SuccessResponse_DishCatalogItem_ } from '../models/SuccessResponse_DishCatalogItem_';
import type { SuccessResponse_DishCatalogResponse_ } from '../models/SuccessResponse_DishCatalogResponse_';
import type { SuccessResponse_FlowConversion_ } from '../models/SuccessResponse_FlowConversion_';
import type { SuccessResponse_OwnerHomeMonthCompareTrend_ } from '../models/SuccessResponse_OwnerHomeMonthCompareTrend_';
import type { SuccessResponse_OwnerHomeSummary_ } from '../models/SuccessResponse_OwnerHomeSummary_';
import type { SuccessResponse_OwnerHomeTrend_ } from '../models/SuccessResponse_OwnerHomeTrend_';
import type { SuccessResponse_ReviewFeed_ } from '../models/SuccessResponse_ReviewFeed_';
import type { SuccessResponse_ReviewItem_ } from '../models/SuccessResponse_ReviewItem_';
import type { SuccessResponse_ReviewOverview_ } from '../models/SuccessResponse_ReviewOverview_';
import type { SuccessResponse_ReviewTrend_ } from '../models/SuccessResponse_ReviewTrend_';
import type { SuccessResponse_TodayRealtime_ } from '../models/SuccessResponse_TodayRealtime_';
import type { SuccessResponse_TodayTrend_ } from '../models/SuccessResponse_TodayTrend_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OwnerHomeService {
    /**
     * Get Owner Home Summary Endpoint
     * GET /api/v1/owner-home/summary — 老板/超管/区域/店长/财务经营总览聚合 (只读).
     *
     * super_admin god-mode 由 require_role 自动放行 (auth.py:285).
     * owner/area_manager/store_manager/finance 由 OWNER_HOME_READ 白名单放行; area_manager
     * 的可见范围被 service 层 visible_store_ids 锁定为名下门店子集 (设计 §2.1), finance
     * 在经营总览语境读取全直营。service 层有防御性二次校验, 双层兜底.
     * @returns SuccessResponse_OwnerHomeSummary_ Successful Response
     * @throws ApiError
     */
    public static getOwnerHomeSummaryEndpointApiV1OwnerHomeSummaryGet({
        storeId,
        month,
    }: {
        /**
         * 下钻单店视图: 须在 actor 可见集内, 越权 403 (2026-07-07)
         */
        storeId?: (number | null),
        /**
         * 周期选择器 (YYYY-MM, Admin 经营总览 2026-07-11)。缺省=当月, 行为与改动前一致。 过去月取到月末; 当月取到今天(不取月末: 否则回填时会把未来日算进本月累计); 未来月 422 — 那不是'没数据', 是问了个没意义的问题, 返 0 会被读成'一分没赚'。
         */
        month?: (string | null),
    }): CancelablePromise<SuccessResponse_OwnerHomeSummary_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/summary',
            query: {
                'store_id': storeId,
                'month': month,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Anomaly Evidence Endpoint
     * GET /api/v1/owner-home/anomaly-evidence — 点开某条 anomaly 的证据 (懒加载, 只读).
     *
     * 异常弹层证据化 (Ricky 2026-06-11; 规格 docs/prd/anomaly-signals/evidence-design.md):
     * 弹层自含全部证据、不跳转。按 rule_key 返回 typed 证据 (汇总句 summary_text 永有 +
     * 明细行 rows≤5 + total_count "共 N 笔" + compare 营收两列对比小表 + detail_available
     * 门控 P1 切片 + 可选 secondary_link 仅 inventory/attendance)。
     *
     * 鉴权与 owner-home 其它端点逐字一致: require_binding_active + require_role(owner/
     * area_manager) + super_admin god-mode 自动放行 (auth.py:285); service 层
     * actor_can_see_business_store(store_id) → 否则 403 STORE_ACCESS_DENIED (area_manager 仅名下店)。
     * rule_key 非法 → 422; store_id 必填; date 选填。
     * @returns SuccessResponse_AnomalyEvidence_ Successful Response
     * @throws ApiError
     */
    public static getAnomalyEvidenceEndpointApiV1OwnerHomeAnomalyEvidenceGet({
        storeId,
        ruleKey,
        date,
    }: {
        /**
         * 门店 id (须在可见集内, 否则 403)
         */
        storeId: number,
        /**
         * 异常规则 key (∈ AnomalyRuleKey; 非法 → 422)
         */
        ruleKey: string,
        /**
         * 锚日 YYYY-MM-DD (选填; 缺省=该店该 rule 最新有数锚日)
         */
        date?: (string | null),
    }): CancelablePromise<SuccessResponse_AnomalyEvidence_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/anomaly-evidence',
            query: {
                'store_id': storeId,
                'rule_key': ruleKey,
                'date': date,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Owner Home Trend Endpoint
     * GET /api/v1/owner-home/trend — 全局 (可见店聚合) 日营收趋势折线数据 (只读).
     *
     * 驾驶舱 2.0 (v0.17 包5, 设计 §3.3). RLS scoped (visible_store_ids + ANY(:ids));
     * super_admin god-mode 由 require_role 放行; area_manager 仅名下店聚合 (绝不全公司).
     * @returns SuccessResponse_OwnerHomeTrend_ Successful Response
     * @throws ApiError
     */
    public static getOwnerHomeTrendEndpointApiV1OwnerHomeTrendGet({
        days = 30,
        month,
        perStore = true,
    }: {
        /**
         * 窗口天数, 白名单 7/14/30/90
         */
        days?: number,
        /**
         * 周期选择器 (YYYY-MM)。给定时窗口=那一整个月(右界锚到月末, 当月锚今天), **days 被忽略** —— 月长 28/29/30/31 天不在 days 白名单里, 硬套 30 天会让 2 月多带两天上个月的数据、1 月少一天。缺省(None)=按 days 走, 行为不变。
         */
        month?: (string | null),
        /**
         * 是否带 per-store 日序 (web small-multiples; 移动端可关省流)
         */
        perStore?: boolean,
    }): CancelablePromise<SuccessResponse_OwnerHomeTrend_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/trend',
            query: {
                'days': days,
                'month': month,
                'per_store': perStore,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Owner Home Month Compare Endpoint
     * GET /api/v1/owner-home/month-compare — 滚动窗口营收对比 (折线图, Ricky 2026-06-08 改).
     *
     * 近 window 天 (实线) vs 上一个 window 天 (同位虚线): window=7 → 近7天 vs 上7天 (同星期几);
     * window=30 → 近30天 vs 上30天。RLS scoped (visible_store_ids + ANY(:ids)); area_manager 仅
     * 名下店聚合 (绝不全公司)。品牌过滤在可见性之后叠加 (dim_store.brand_id 派生); 非法 brand → 422。
     * window 非 7/30 → 归一到 7 (前端仅发 7/30)。
     * @returns SuccessResponse_OwnerHomeMonthCompareTrend_ Successful Response
     * @throws ApiError
     */
    public static getOwnerHomeMonthCompareEndpointApiV1OwnerHomeMonthCompareGet({
        brand = 'all',
        window = 7,
    }: {
        /**
         * 品牌: all | yss (尹三顺) | qjx (俏江溪)
         */
        brand?: string,
        /**
         * 窗口天数: 7 (近7天vs上7天) | 30 (近30天vs上30天)
         */
        window?: number,
    }): CancelablePromise<SuccessResponse_OwnerHomeMonthCompareTrend_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/month-compare',
            query: {
                'brand': brand,
                'window': window,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Today Realtime Endpoint
     * GET /api/v1/owner-home/today — 今日实时 (各店营业额/排队 + 翻台/上座/订单 + 汇总, 只读).
     *
     * goal 阶段2 Ember 消费侧。读 mart_export.pos_today_realtime (当日 data_date=CURRENT_DATE
     * 快照, 营业时段每 15min 刷新; 营业额/订单/翻台/上座 仅直营有数, 排队 queue_count 全店都采)。
     * totals 主推 营业额 + 排队总计 (total_queue_tables = sum queue_count); as_of = max(captured_at)
     * 供前端「X 分钟前更新」新鲜度。门店关/未采 → 优雅返回 0/None, 不 500。品牌过滤在 actor
     * 可见性之后叠加 (pos_today_realtime 无 brand_id, 用 dim_store.brand_id 派生)。RLS scoped
     * (visible_store_ids + ANY(:ids)); area_manager 仅名下店; store_manager 为店长页竞争氛围只读榜,
     * finance 为 Admin 全直营榜; 单店下钻权限由独立 manager-home 端点继续校验。
     * 开台数二期再做。
     * @returns SuccessResponse_TodayRealtime_ Successful Response
     * @throws ApiError
     */
    public static getTodayRealtimeEndpointApiV1OwnerHomeTodayGet({
        brand = 'all',
    }: {
        /**
         * 品牌: all | yss (尹三顺) | qjx (俏江溪)
         */
        brand?: string,
    }): CancelablePromise<SuccessResponse_TodayRealtime_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/today',
            query: {
                'brand': brand,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Today Trend Endpoint
     * GET /api/v1/owner-home/today-trend — 今日走势 (实时 tab) 三条线 (只读).
     *
     * today (今日小时 GMV 实线, 到当前小时) + last_week (上周同日小时虚线, 全天) +
     * last_month (上月同日小时虚线, 全天)。每点 {t:"HH:00", v:该小时直营合计 GMV 元}。
     * today 源 mart_export.pos_today_gmv_series
     * (当日累计快照, 按小时桶取末值 carry-forward 后逐时差分);
     * 历史源 mart_export.fact_store_hourly_pos (time_slot 增量 → 跨店求和)。
     * 当前小时是半截实时值, 前端主图按 as_of 过滤, 摘要单独展示。
     * RLS scoped (visible_store_ids + ANY(:ids)); area_manager 仅名下店 (PIT-018); 品牌过滤在
     * 可见性之后叠加 (dim_store.brand_id 派生)。源缺失/未采 → 对应 series 空数组, 不 500。
     * as_of = today 序最新 captured_at (+08:00)。
     * @returns SuccessResponse_TodayTrend_ Successful Response
     * @throws ApiError
     */
    public static getTodayTrendEndpointApiV1OwnerHomeTodayTrendGet({
        brand = 'all',
    }: {
        /**
         * 品牌: all | yss (尹三顺) | qjx (俏江溪)
         */
        brand?: string,
    }): CancelablePromise<SuccessResponse_TodayTrend_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/today-trend',
            query: {
                'brand': brand,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Flow Conversion Endpoint
     * GET /api/v1/owner-home/flow — 流量转化 (漏斗+来源+品牌对比+排行+转化率趋势+互动深度, 只读).
     *
     * 读 mart.store_flow_30d (近 30 天滚动; 卡片取 max(data_date)=昨日那行; 趋势 = 各 data_date
     * 滚动值连线 + 每点两转化率; 同比 yoy_pct = 接口内置 本 30 天 vs 上 30 天 POP, 非去年同期).
     * 比率范围级重算 (sum/sum); 范围同比反推上期值求和 (防除零). brands 块只返可见范围内
     * 实际存在的品牌 (尹三顺/俏江溪). 品牌过滤在 actor 可见性之后叠加 (先 RLS 收可见店再按
     * brand 过滤). RLS scoped (visible_store_ids + ANY(:ids)); area_manager 仅名下店 (PIT-018).
     * @returns SuccessResponse_FlowConversion_ Successful Response
     * @throws ApiError
     */
    public static getFlowConversionEndpointApiV1OwnerHomeFlowGet({
        brand = 'all',
        channel = 'meituan',
        storeId,
    }: {
        /**
         * 品牌: all | yss (尹三顺) | qjx (俏江溪)
         */
        brand?: string,
        /**
         * 渠道: meituan (暂仅美团; 参数留给未来抖音)
         */
        channel?: string,
        /**
         * 可选, 限定单店 (须在可见集内, 否则 403)
         */
        storeId?: (number | null),
    }): CancelablePromise<SuccessResponse_FlowConversion_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/flow',
            query: {
                'brand': brand,
                'channel': channel,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Crowd Structure Endpoint
     * GET /api/v1/owner-home/crowd — 人群结构 (构成/画像/客源地/忠诚度/同行对比, 只读).
     *
     * 读 mart.store_crowd_{weekly,monthly} + catchment (周/月窗, 最新窗).
     * 计数范围 SUM; 复购率范围级重算; 画像/客源地按项 SUM; 人均按 sold_num 加权;
     * 同行对比 = 各店 *PeerComparison delta (人数 net + 复购率优于同行店数). 品牌过滤在可见性之后叠加.
     * RLS scoped (visible_store_ids + ANY(:ids)); area_manager 仅名下店.
     * @returns SuccessResponse_CrowdStructure_ Successful Response
     * @throws ApiError
     */
    public static getCrowdStructureEndpointApiV1OwnerHomeCrowdGet({
        brand = 'all',
        period = 'week',
        platform = 2,
        storeId,
    }: {
        /**
         * 品牌: all | yss (尹三顺) | qjx (俏江溪)
         */
        brand?: string,
        /**
         * 窗口: week (周窗) | month (月窗)
         */
        period?: string,
        /**
         * 平台: 0美团 1点评 2美团+点评(默认)
         */
        platform?: number,
        /**
         * 可选, 限定单店 (须在可见集内, 否则 403)
         */
        storeId?: (number | null),
    }): CancelablePromise<SuccessResponse_CrowdStructure_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/crowd',
            query: {
                'brand': brand,
                'period': period,
                'platform': platform,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Consumption Structure Endpoint
     * GET /api/v1/owner-home/consumption — 消费点单 (价值链③, 只读).
     *
     * 读 mart.store_consumption_{daily,dish_30d,category_30d,scene_30d,mealperiod_30d,attach_30d}
     * (近 30 天). summary 从 daily 范围汇总 (客单价/单均/营收/人头/订单/会员占比/服务费, 比率段级
     * 重算); top_dishes 跨可见店合并按 income 取 Top~15; categories/scenes/meal_periods 段级重算;
     * attach 范围级按 sum(单数)/sum(order) 重算 (不平均各店 %) + 各店列表; stores 每店 summary.
     * 品牌过滤在可见性之后叠加. RLS scoped (visible_store_ids + ANY(:ids)); area_manager 仅名下店.
     * @returns SuccessResponse_ConsumptionStructure_ Successful Response
     * @throws ApiError
     */
    public static getConsumptionStructureEndpointApiV1OwnerHomeConsumptionGet({
        brand = 'all',
        platform = 2,
        storeId,
    }: {
        /**
         * 品牌: all | yss (尹三顺) | qjx (俏江溪)
         */
        brand?: string,
        /**
         * 平台: 0美团 1点评 2美团+点评 (回显, 口径同 crowd)
         */
        platform?: number,
        /**
         * 可选, 限定单店 (须在可见集内, 否则 403)
         */
        storeId?: (number | null),
    }): CancelablePromise<SuccessResponse_ConsumptionStructure_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/consumption',
            query: {
                'brand': brand,
                'platform': platform,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Dish Catalog Endpoint
     * GET /api/v1/owner-home/dish-categories — 品类维护列表 (只读, binding-active).
     *
     * 读 mart.dish_catalog (品牌级主数据, 关键词自动分类) + ops.dish_category_override
     * (owner / finance 覆盖层) 合并出生效品类 + 来源 + item_kind, 未归类优先排序 + 按
     * qty_30d desc。GET 不叠 role gate, 但保留 require_binding_active; 未绑定 finance
     * 只有签名 Admin 来源可例外。brand 必填 (yss/qjx; 不含 all, 非法 → 422)。
     * @returns SuccessResponse_DishCatalogResponse_ Successful Response
     * @throws ApiError
     */
    public static getDishCatalogEndpointApiV1OwnerHomeDishCategoriesGet({
        brand,
    }: {
        /**
         * 品牌: yss (尹三顺) | qjx (俏江溪); 不含 all
         */
        brand: string,
    }): CancelablePromise<SuccessResponse_DishCatalogResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/dish-categories',
            query: {
                'brand': brand,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Put Dish Category Endpoint
     * PUT /api/v1/owner-home/dish-categories/{brand}/{dish_code} — 财务/老板写品类覆盖.
     *
     * upsert ops.dish_category_override (手动改单菜品类)。中央
     * `DISH_CATEGORY_WRITE` 仅含 finance / owner, super_admin 走审计旁路;
     * area_manager/manager/店员全部挡住。category 必须 ∈ 该 brand 允许品类, 否则 400。
     * 成功返回更新后的 DishCatalogItem (生效品类 source='boss')。brand 非法 → 422。
     * @returns SuccessResponse_DishCatalogItem_ Successful Response
     * @throws ApiError
     */
    public static putDishCategoryEndpointApiV1OwnerHomeDishCategoriesBrandDishCodePut({
        brand,
        dishCode,
        requestBody,
    }: {
        brand: string,
        dishCode: string,
        requestBody: DishCategoryUpdate,
    }): CancelablePromise<SuccessResponse_DishCatalogItem_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/owner-home/dish-categories/{brand}/{dish_code}',
            path: {
                'brand': brand,
                'dish_code': dishCode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Review Overview Endpoint
     * GET /api/v1/owner-home/reviews/overview — 评价门店榜 + 汇总 (只读).
     *
     * 读 mart.store_review_daily_summary, 范围内按 store 聚合好/差/中. 门店榜含全部直营店
     * (无评价补 0, 与 owner-home 门店对比口径一致). 锚日 = max(data_date)<=current_date.
     * store_id 可选 (店长口碑本店化 2026-07-08): 汇总/榜/标签收敛单店.
     * RLS scoped (visible_store_ids + ANY(:ids)); area_manager 仅名下店 (绝不全公司).
     * @returns SuccessResponse_ReviewOverview_ Successful Response
     * @throws ApiError
     */
    public static getReviewOverviewEndpointApiV1OwnerHomeReviewsOverviewGet({
        range = 'yesterday',
        source = 'all',
        storeId,
    }: {
        /**
         * 范围: yesterday (锚日) | 7d (锚日-6..锚日)
         */
        range?: string,
        /**
         * 来源: all | public | table_visit
         */
        source?: string,
        /**
         * 可选, 限定单店 (汇总/榜/标签收敛到该店; 不可见 403)
         */
        storeId?: (number | null),
    }): CancelablePromise<SuccessResponse_ReviewOverview_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/reviews/overview',
            query: {
                'range': range,
                'source': source,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Review Trend Endpoint
     * GET /api/v1/owner-home/reviews/trend — 评价趋势 (按日期聚合好/差, 只读).
     *
     * 读 mart.store_review_daily_summary, 范围内按 data_date 聚合好/差 (跨可见店). points 为
     * 范围内每一天一条 (连续日序, 缺数据的天补 good=0 bad=0). 锚日 = max(data_date)<=current_date.
     * store_id 可选 (店长口碑本店化 2026-07-08): 单店趋势.
     * RLS scoped (visible_store_ids + ANY(:ids)); area_manager 仅名下店 (绝不全公司).
     * @returns SuccessResponse_ReviewTrend_ Successful Response
     * @throws ApiError
     */
    public static getReviewTrendEndpointApiV1OwnerHomeReviewsTrendGet({
        range = '7d',
        source = 'all',
        storeId,
    }: {
        /**
         * 范围: 7d (锚日-6..锚日) | 30d (锚日-29..锚日)
         */
        range?: string,
        /**
         * 来源: all | public | table_visit
         */
        source?: string,
        /**
         * 可选, 限定单店趋势 (不可见 403)
         */
        storeId?: (number | null),
    }): CancelablePromise<SuccessResponse_ReviewTrend_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/reviews/trend',
            query: {
                'range': range,
                'source': source,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Review Feed Endpoint
     * GET /api/v1/owner-home/reviews — 评价内容流 (只读).
     *
     * 读 mart.store_review_detail, 过滤 范围 + sentiment + 可选 store_id。
     * 按 review_date desc 排 (同日按 store_id), 上限 200 条 (超了截断 + truncated=True).
     * 锚日 = max(review_date)<=current_date. RLS scoped (visible_store_ids + ANY(:ids)).
     * @returns SuccessResponse_ReviewFeed_ Successful Response
     * @throws ApiError
     */
    public static getReviewFeedEndpointApiV1OwnerHomeReviewsGet({
        range = 'yesterday',
        sentiment = 'bad',
        storeId,
    }: {
        /**
         * 范围: yesterday | 7d | 30d
         */
        range?: string,
        /**
         * bad (差评) | neutral (中评) | good (好评) | all (三类全部)
         */
        sentiment?: string,
        /**
         * 可选, 限定单店 (须在可见直营集内, 否则 403)
         */
        storeId?: (number | null),
    }): CancelablePromise<SuccessResponse_ReviewFeed_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/reviews',
            query: {
                'range': range,
                'sentiment': sentiment,
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Review By Id Endpoint
     * 按 canonical review_id 读取单条评价, 不受普通内容流时间窗限制。
     *
     * 不存在与当前 actor 不可见统一 404; 报表源缺失/缺权/查询失败或 ID 唯一性失守返回
     * 503。只读且复用 ReviewItem, 不接受 source_id 或内容哈希 fallback。
     * @returns SuccessResponse_ReviewItem_ Successful Response
     * @throws ApiError
     */
    public static getReviewByIdEndpointApiV1OwnerHomeReviewsByIdReviewIdGet({
        reviewId,
    }: {
        /**
         * mart.store_review_detail 的 canonical review_id
         */
        reviewId: string,
    }): CancelablePromise<SuccessResponse_ReviewItem_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/reviews/by-id/{review_id}',
            path: {
                'review_id': reviewId,
            },
            errors: {
                404: `评价不存在或不在当前可见门店范围`,
                422: `Validation Error`,
                503: `评价报表源不可用或 canonical review_id 唯一性失守`,
            },
        });
    }
    /**
     * Get Daily Report Endpoint
     * GET /api/v1/owner-home/daily-report — 报告中心日报 (4 块, 只读).
     *
     * 原生重画 Hermes 09:50 PDF 日报。①panels 三口径 (全盘/直营尹三顺/直营俏江溪, 营业额/客流/
     * 周同日%口径级重算/近7天 sparkline) + ②store_groups 全 26 店分组 (直营/投资/加盟, 全局 rank +
     * 营收/月达成/订单/客流/客单/周同日%/好评率/差评数/折扣汇总/sparkline) + ③discounts 直营折扣
     * 逐笔 (切片表未建→discount_available=false 空态) + ④bad_reviews 直营差评逐条 (sentiment=差评)。
     * 范围: ①② 全 26 可见店; ③④ 仅直营 (Ricky 2026-06-08 拍板)。统一锚日 (设计 §9 R6)。
     * RLS scoped (visible_store_ids + ANY(:ids), PIT-018; area_manager 仅名下店, 绝不全公司)。
     * 优雅降级: 任一块表缺/缺权/隧道断 → 块返空 + blocks_available.<块>=false, HTTP 仍 200。
     * @returns SuccessResponse_DailyReport_ Successful Response
     * @throws ApiError
     */
    public static getDailyReportEndpointApiV1OwnerHomeDailyReportGet({
        date,
    }: {
        /**
         * 报告日 YYYY-MM-DD; 缺省=最新可用日 max(data_date)<=今日。非法格式 → 422
         */
        date?: (string | null),
    }): CancelablePromise<SuccessResponse_DailyReport_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/daily-report',
            query: {
                'date': date,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Daily Report Dates Endpoint
     * GET /api/v1/owner-home/daily-report/dates — 可用日期列表 + latest_date (只读).
     *
     * 历史翻看 (前端据 dates 渲染可点日期) + 首页角标判未读 (latest_date)。「可用日」=
     * store_daily_kpi 在可见店集内有数据的 data_date (降序, <=今日, 上限 limit)。轻量端点。
     * RLS scoped (visible_store_ids + ANY(:ids), PIT-018)。缺表/隧道断 → 空 (200)。
     * @returns SuccessResponse_DailyReportDates_ Successful Response
     * @throws ApiError
     */
    public static getDailyReportDatesEndpointApiV1OwnerHomeDailyReportDatesGet({
        limit = 60,
    }: {
        /**
         * 返回最近 N 天 (默认 60, 上限 365)
         */
        limit?: number,
    }): CancelablePromise<SuccessResponse_DailyReportDates_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/daily-report/dates',
            query: {
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Daily Report Image Endpoint
     * GET /api/v1/owner-home/daily-report/image — 日报「一键转发长图」取图 (raw PNG, 只读缓存).
     *
     * 设计 2026-06-08 §5: 转发图 = 全量「集团日报」长图。**finance / owner / super_admin**
     * 可读 (super_admin 由 require_role 旁路放行; **area_manager 不在白名单 → 403**,
     * 角色级拒绝, 既免逐 scope 出图又免数据泄漏)。**端点永不在 API 进程内起 chromium**
     * (设计采纳 #4, 2 核 2G 防 OOM):
     * - 锚日解析 (resolve_report_anchor, 与 app 页同锚日) None → 404 DAILY_REPORT_NO_DATA;
     * - read_cached 命中 → 200 image/png (零渲染 serve 静态文件, 绝大多数走这条);
     * - miss → 503 DAILY_REPORT_IMAGE_UNAVAILABLE + Retry-After:120 (不渲染, 等下一档 timer)。
     * 渲染只发生在 systemd timer (scripts.render_daily_report_image)。limit 防鉴权后高频拉图。
     * @returns any 日报转发长图 PNG
     * @throws ApiError
     */
    public static getDailyReportImageEndpointApiV1OwnerHomeDailyReportImageGet({
        date,
    }: {
        /**
         * 报告日 YYYY-MM-DD; 缺省=最新锚日 max(data_date)<=今日。非法格式 → 422
         */
        date?: (string | null),
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/owner-home/daily-report/image',
            query: {
                'date': date,
            },
            errors: {
                403: `角色非 finance/owner/super_admin (area_manager 等)`,
                404: `该锚日无数据 (DAILY_REPORT_NO_DATA)`,
                422: `Validation Error`,
                503: `图未渲好缓存 miss (DAILY_REPORT_IMAGE_UNAVAILABLE) + Retry-After`,
            },
        });
    }
}
